import React, { useEffect, useRef } from 'react';

// Import airline logos (normal React imports, not Next.js)
import etihad from '../../../assets/Service-icon/etihad-airways.svg';
import airindia from '../../../assets/Service-icon/air-india.svg';
import singapore from '../../../assets/Service-icon/singapore-airlines.svg';
import indigo from '../../../assets/Service-icon/indigo.svg';
import vistara from '../../../assets/Service-icon/vistara.svg';
import akasa from '../../../assets/Service-icon/Akasa Air.svg';
import emirates from '../../../assets/Service-icon/emirates-airlines.svg';
import airfrance from '../../../assets/Service-icon/air-france.svg';

const TicketPartners = () => {
  const logos = [
    { src: etihad, alt: 'Etihad' },
    { src: airindia, alt: 'Air India' },
    { src: singapore, alt: 'Singapore Airlines' },
    { src: indigo, alt: 'IndiGo' },
    { src: vistara, alt: 'Vistara' },
    { src: akasa, alt: 'Akasa Air' },
    { src: emirates, alt: 'Emirates' },
    { src: airfrance, alt: 'Air France' },
  ];

  const containerRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    let animationFrame;
    let x = 0;

    const scroll = () => {
      if (contentRef.current) {
        x -= 1; // Speed (lower = slower, higher = faster)
        const width = contentRef.current.scrollWidth / 2;

        if (Math.abs(x) >= width) {
          x = 0; // Reset when half scrolled
        }

        contentRef.current.style.transform = `translateX(${x}px)`;
      }
      animationFrame = requestAnimationFrame(scroll);
    };

    animationFrame = requestAnimationFrame(scroll);

    return () => cancelAnimationFrame(animationFrame);
  }, []);

  return (
    <div className='px-4 py-10 text-center'>
      <h1 className='mb-6 text-3xl font-extrabold leading-snug text-gray-900 md:text-6xl'>
        Our Ticketing Partners
      </h1>

      <div
        ref={containerRef}
        className='relative w-full overflow-hidden'
      >
        <div
          ref={contentRef}
          className='flex whitespace-nowrap will-change-transform'
        >
          {logos.concat(logos).map((logo, index) => (
            <div
              key={index}
              className='mx-10 flex h-[120px] flex-shrink-0 items-center justify-center md:h-[160px] lg:h-[200px]'
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className='h-full w-32 object-contain'
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TicketPartners;
